var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { GroupHeader } from "@ane/ui-components/lib/components/GroupedList";
import { SelectionMode } from "@ane/ui-components/lib/Utilities";
import { ConstrainMode } from "@ane/ui-components/lib/components/DetailsList";
import { DetailsListWithCommandBar } from "@ane/ui-components/lib/components/DetailsList/DetailsListWithCommandBar";
function GetSubClisterListWhenAddChild(originalList, defaultChild) {
  originalList.forEach((item) => {
    item.collapsed = true;
  });
  defaultChild.collapsed = false;
  originalList = [...originalList, defaultChild];
  return originalList;
}
class SubClusterList extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "_getCommandItems", () => {
      const { isReadOnly } = this.props;
      const disabled = !!isReadOnly;
      return [
        {
          key: "addRow",
          text: "Add sub-cluster",
          disabled,
          iconProps: {
            iconName: "Add"
          },
          onClick: this.props.onAddSubCluster
        },
        {
          key: "deleteRow",
          text: "Delete",
          disabled,
          iconProps: {
            iconName: "Delete"
          },
          onClick: this.props.onDeleteSubCluster
        }
      ];
    });
    __publicField(this, "_onRenderGroupHeader", (props) => /* @__PURE__ */ jsx(
      GroupHeader,
      __spreadProps(__spreadValues({}, props), {
        styles: { headerCount: { display: "none" }, check: { opacity: 1 } },
        onToggleCollapse: (group) => {
          if (props && props.onToggleCollapse) {
            props == null ? void 0 : props.onToggleCollapse(group);
          }
          if (group.data) {
            group.data.collapsed = group.isCollapsed;
          }
        },
        ariaColSpan: 1
      })
    ));
    __publicField(this, "_getSubClusterGroups", () => {
      const { subClusterList } = this.props;
      return subClusterList.map((item, index) => {
        var _a;
        let groupName = "Sub-cluster " + (index + 1);
        return {
          key: groupName,
          name: groupName,
          startIndex: index,
          count: 1,
          data: item,
          isCollapsed: (_a = item.collapsed) != null ? _a : false
        };
      });
    });
  }
  render() {
    return /* @__PURE__ */ jsx(
      DetailsListWithCommandBar,
      {
        commandBarProps: {
          items: this._getCommandItems(),
          ariaLabel: "Create sub cluster command"
        },
        detailsListProps: {
          compact: true,
          columns: [
            {
              key: "subClusters",
              name: "Sub-clusters",
              fieldName: "subClusters",
              minWidth: 100,
              maxWidth: 200,
              isResizable: true
            }
          ],
          defaultSortColumn: "",
          disableSort: true,
          ariaLabelForGrid: "sub cluster list",
          constrainMode: ConstrainMode.unconstrained,
          selection: this.props.selection,
          selectionMode: SelectionMode.multiple,
          onRenderRow: (item) => this.props.onRenderSubCluster(item),
          groupProps: {
            onRenderHeader: this._onRenderGroupHeader
          },
          items: this.props.subClusterList,
          groups: this._getSubClusterGroups(),
          ariaLabelForSelectAllCheckbox: "Toggle selection for all items",
          ariaLabelForSelectionColumn: "Toggle selection",
          checkButtonAriaLabel: "Row checkbox"
        }
      }
    );
  }
}
export {
  GetSubClisterListWhenAddChild,
  SubClusterList
};
//# sourceMappingURL=SubClusterList.js.map
